<template>
  <main class="recruit-page">
    <section class="recruit-intro">
      <div class="recruit-shell intro-inner">
        <div class="intro-copy">
          <span class="eyebrow">JOIN ZHIRONG</span>
          <h1>与懂能源的人，一起创造长期价值</h1>
          <p>面向储能、重卡换电等核心业务，持续寻找专业、务实、有创造力的同行者。</p>
        </div>
        <div class="intro-stat" aria-label="当前招聘岗位数量">
          <strong>{{ jobs.length }}</strong>
          <span>个在招岗位</span>
        </div>
      </div>
    </section>

    <section class="recruit-shell position-section">
      <header class="section-heading">
        <div>
          <span class="eyebrow">OPEN POSITIONS</span>
          <h2>招聘职位</h2>
        </div>
        <p>点击岗位卡片查看完整职责与任职要求</p>
      </header>

      <div class="job-list">
        <article
          v-for="(job, index) in jobs"
          :key="job.title"
          class="job-card"
          :class="{ expanded: isExpanded(index) }"
        >
          <button
            class="job-summary"
            type="button"
            :aria-expanded="isExpanded(index) ? 'true' : 'false'"
            @click="toggleJob(index)"
          >
            <span class="job-number">{{ formatIndex(index) }}</span>
            <span class="job-main">
              <strong>{{ job.title }}</strong>
              <span class="job-tags">
                <span v-for="tag in job.tags" :key="tag">{{ tag }}</span>
              </span>
            </span>
            <span class="toggle-icon" aria-hidden="true">
              <i></i>
              <i></i>
            </span>
          </button>

          <transition name="job-expand">
            <div v-show="isExpanded(index)" class="job-details">
              <div class="detail-grid" :class="{ single: !job.responsibilities.length }">
                <section v-if="job.responsibilities.length" class="detail-block">
                  <div class="detail-title">
                    <span class="detail-icon responsibility-icon"></span>
                    <div>
                      <small>RESPONSIBILITIES</small>
                      <h3>岗位职责</h3>
                    </div>
                  </div>
                  <ol>
                    <li v-for="item in job.responsibilities" :key="item">{{ item }}</li>
                  </ol>
                </section>

                <section class="detail-block qualification-block">
                  <div class="detail-title">
                    <span class="detail-icon qualification-icon"></span>
                    <div>
                      <small>QUALIFICATIONS</small>
                      <h3>{{ job.qualificationTitle }}</h3>
                    </div>
                  </div>
                  <ol>
                    <li v-for="item in job.qualifications" :key="item">{{ item }}</li>
                  </ol>
                </section>
              </div>
            </div>
          </transition>
        </article>
      </div>

      <aside class="delivery-card">
        <div class="mail-visual" aria-hidden="true">
          <span></span>
        </div>
        <div class="delivery-copy">
          <span class="eyebrow">READY TO JOIN US?</span>
          <h2>期待你的加入</h2>
          <p>请将个人简历发送至招聘邮箱，邮件主题建议注明“应聘岗位 + 姓名”。</p>
        </div>
        <a class="mail-link" href="mailto:zhirongtechnology@163.com">
          <span>简历投递邮箱</span>
          <strong>zhirongtechnology@163.com</strong>
          <i class="el-icon-right"></i>
        </a>
      </aside>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    return {
      expandedIndexes: [0],
      jobs: [
        {
          title: "技术解决方案负责人",
          tags: ["技术管理", "储能及重卡换电", "售前解决方案"],
          qualificationTitle: "任职资格",
          responsibilities: [
            "负责搭建电网侧储能及重卡换电全场景解决方案体系，制定标准化架构、选型标准与收益模型，推进降本增效。",
            "负责对接政企、电网及物流车企等核心客户，深度挖掘诉求，输出定制化整体解决方案与商业化模式。",
            "负责储能系统（PCS/BMS/EMS/消防温控）及重卡换电系统（换电机构/PACK/调度平台）一体化架构方案。",
            "牵头技术交底、谈判与宣讲，输出可研报告、技术协议、收益测算及全套标书技术文件，保障中标率。",
            "协同投资团队开展项目尽调与选址评估，协同工程与供应链完成设备选型、接口定义及建设期技术答疑。",
            "协同运营团队优化运维方案与调度逻辑，统筹项目全生命周期技术风险管控。",
            "跟踪行业政策、技术迭代与竞品动态，持续打造差异化竞争优势，支撑公司新业务拓展。",
            "负责团队日常管理、技能赋能及售前知识库与工具库沉淀。",
          ],
          qualifications: [
            "本科及以上学历，电气工程、电力系统、新能源、自动化、车辆工程等相关专业，硕士优先。",
            "8年以上新能源行业解决方案/售前管理经验，其中至少5年团队管理经验。",
            "具备电网侧储能（GW级）+ 重卡换电双赛道全流程方案设计、投标及落地项目经验。",
            "熟悉电网侧储能架构、并网标准及调频调峰逻辑或重卡换电站系统设计、建设规范及场站运营。",
            "熟悉储能“投建营”与重卡换电“车电分离”商业模式，精通项目成本核算与投资收益测算模型。",
            "具备售前技术讲解及商务谈判能力，具备跨部门统筹能力与抗压能力，可适应高频出差。",
          ],
        },
        {
          title: "储能销售",
          tags: ["储能业务", "客户拓展", "商务销售"],
          qualificationTitle: "任职要求",
          responsibilities: [],
          qualifications: [
            "本科及以上学历，5年以上销售经验，3年以上新能源/电力行业（大储）从业经历。",
            "具备丰富的能源行业客户资源，熟悉储能市场趋势。",
            "拥有出色的商务谈判与抗压能力。",
          ],
        },
      ],
    };
  },
  methods: {
    isExpanded(index) {
      return this.expandedIndexes.includes(index);
    },
    toggleJob(index) {
      const pos = this.expandedIndexes.indexOf(index);
      if (pos > -1) {
        this.expandedIndexes.splice(pos, 1);
      } else {
        this.expandedIndexes.push(index);
      }
    },
    formatIndex(index) {
      return String(index + 1).padStart(2, "0");
    },
  },
};
</script>

<style lang="scss" scoped>
.recruit-page {
  color: #122343;
  background:
    radial-gradient(circle at 92% 10%, rgba(54, 111, 237, 0.09), transparent 28%),
    #f5f7fb;
  overflow: hidden;
}

.recruit-shell {
  width: calc(100% - 64px);
  max-width: 1400px;
  margin: 0 auto;
}

.eyebrow {
  display: block;
  margin-bottom: 14px;
  color: #3269e8;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px;
}

.recruit-intro {
  position: relative;
  padding: 90px 0 78px;
  color: #fff;
  background:
    linear-gradient(115deg, rgba(8, 31, 79, 0.98), rgba(30, 88, 204, 0.91)),
    url("../images/recruitBg.png") center / cover no-repeat;

  &::after {
    position: absolute;
    right: -100px;
    bottom: -260px;
    width: 560px;
    height: 560px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 50%;
    box-shadow: 0 0 0 80px rgba(255, 255, 255, 0.025), 0 0 0 160px rgba(255, 255, 255, 0.018);
    content: "";
  }
}

.intro-inner {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 50px;
}

.intro-copy {
  max-width: 780px;

  .eyebrow {
    color: #93b8ff;
  }

  h1 {
    margin: 0 0 22px;
    font-size: 42px;
    line-height: 1.28;
    letter-spacing: 1px;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.72);
    font-size: 18px;
    line-height: 1.8;
  }
}

.intro-stat {
  display: flex;
  align-items: baseline;
  min-width: 210px;
  padding: 28px 32px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);

  strong {
    margin-right: 12px;
    font-size: 52px;
    line-height: 1;
  }

  span {
    color: rgba(255, 255, 255, 0.78);
    font-size: 16px;
  }
}

.position-section {
  padding: 90px 0 110px;
}

.section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 30px;
  margin-bottom: 36px;

  h2 {
    margin: 0;
    color: #102348;
    font-size: 38px;
  }

  p {
    margin: 0 0 7px;
    color: #7b879b;
    font-size: 15px;
  }
}

.job-list {
  display: grid;
  gap: 18px;
}

.job-card {
  overflow: hidden;
  border: 1px solid #e3e9f3;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(27, 57, 115, 0.055);
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;

  &:hover,
  &.expanded {
    border-color: rgba(50, 105, 232, 0.42);
    box-shadow: 0 20px 45px rgba(34, 77, 169, 0.1);
  }

  &.expanded {
    transform: translateY(-2px);
  }
}

.job-summary {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 30px 34px;
  border: 0;
  color: inherit;
  text-align: left;
  background: transparent;
  cursor: pointer;
}

.job-number {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 58px;
  height: 58px;
  margin-right: 24px;
  border-radius: 16px;
  color: #3269e8;
  font-size: 17px;
  font-weight: 700;
  background: #edf3ff;
}

.job-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
  gap: 24px;

  > strong {
    color: #122343;
    font-size: 24px;
    font-weight: 600;
  }
}

.job-tags {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 9px;

  span {
    padding: 7px 12px;
    border-radius: 20px;
    color: #5e6f8d;
    font-size: 13px;
    white-space: nowrap;
    background: #f4f6fa;
  }
}

.toggle-icon {
  position: relative;
  flex: 0 0 42px;
  height: 42px;
  margin-left: 28px;
  border-radius: 50%;
  background: #f1f5fc;
  transition: background 0.25s ease, transform 0.25s ease;

  i {
    position: absolute;
    top: 20px;
    left: 13px;
    width: 16px;
    height: 2px;
    border-radius: 2px;
    background: #3269e8;
    transition: transform 0.25s ease;

    &:last-child {
      transform: rotate(90deg);
    }
  }
}

.expanded .toggle-icon {
  color: #fff;
  background: #3269e8;
  transform: rotate(180deg);

  i {
    background: #fff;

    &:last-child {
      transform: rotate(0);
    }
  }
}

.job-details {
  border-top: 1px solid #edf0f5;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  gap: 0;
  padding: 38px 34px 42px;

  &.single {
    grid-template-columns: minmax(0, 1fr);
  }
}

.detail-block {
  padding: 0 38px 0 0;

  & + .detail-block {
    padding: 0 0 0 40px;
    border-left: 1px solid #e8edf5;
  }

  ol {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
    counter-reset: job-item;
  }

  li {
    position: relative;
    min-height: 28px;
    margin-bottom: 15px;
    padding-left: 42px;
    color: #52627c;
    font-size: 15px;
    line-height: 1.78;
    counter-increment: job-item;

    &::before {
      position: absolute;
      top: 1px;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 27px;
      height: 27px;
      border-radius: 8px;
      color: #3269e8;
      font-size: 12px;
      font-weight: 700;
      background: #edf3ff;
      content: counter(job-item, decimal-leading-zero);
    }
  }
}

.single .detail-block {
  max-width: 880px;
  padding-right: 0;
}

.detail-title {
  display: flex;
  align-items: center;
  gap: 14px;

  small {
    display: block;
    margin-bottom: 4px;
    color: #94a0b3;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.2px;
  }

  h3 {
    margin: 0;
    color: #152a51;
    font-size: 20px;
  }
}

.detail-icon {
  position: relative;
  display: block;
  flex: 0 0 44px;
  height: 44px;
  border-radius: 13px;
  background: linear-gradient(145deg, #3975f0, #2358d0);

  &::before,
  &::after {
    position: absolute;
    content: "";
  }
}

.responsibility-icon {
  &::before {
    top: 12px;
    left: 13px;
    width: 17px;
    height: 19px;
    border: 2px solid #fff;
    border-radius: 3px;
  }

  &::after {
    top: 17px;
    left: 17px;
    width: 10px;
    height: 2px;
    background: #fff;
    box-shadow: 0 5px 0 #fff, 0 10px 0 #fff;
  }
}

.qualification-icon {
  &::before {
    top: 11px;
    left: 11px;
    width: 18px;
    height: 18px;
    border: 2px solid #fff;
    border-radius: 50%;
  }

  &::after {
    right: 9px;
    bottom: 10px;
    width: 10px;
    height: 2px;
    background: #fff;
    transform: rotate(45deg);
  }
}

.job-expand-enter-active,
.job-expand-leave-active {
  transition: opacity 0.22s ease;
}

.job-expand-enter,
.job-expand-leave-to {
  opacity: 0;
}

.delivery-card {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 28px;
  margin-top: 46px;
  padding: 34px 38px;
  overflow: hidden;
  border-radius: 20px;
  color: #fff;
  background: linear-gradient(115deg, #102b66, #2865df);
  box-shadow: 0 20px 45px rgba(26, 71, 166, 0.18);

  &::after {
    position: absolute;
    right: 23%;
    width: 220px;
    height: 220px;
    border: 1px solid rgba(255, 255, 255, 0.11);
    border-radius: 50%;
    content: "";
  }
}

.mail-visual {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.11);

  span {
    position: relative;
    width: 28px;
    height: 20px;
    border: 2px solid #fff;
    border-radius: 3px;

    &::before,
    &::after {
      position: absolute;
      top: 4px;
      width: 17px;
      height: 2px;
      background: #fff;
      content: "";
    }

    &::before {
      left: -1px;
      transform: rotate(34deg);
    }

    &::after {
      right: -1px;
      transform: rotate(-34deg);
    }
  }
}

.delivery-copy {
  position: relative;
  z-index: 1;

  .eyebrow {
    margin-bottom: 7px;
    color: #a9c5ff;
  }

  h2 {
    margin: 0 0 7px;
    font-size: 25px;
  }

  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
  }
}

.mail-link {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  min-width: 360px;
  padding: 17px 20px;
  border-radius: 13px;
  color: #235bd0;
  text-decoration: none;
  background: #fff;
  transition: transform 0.22s ease, box-shadow 0.22s ease;

  span {
    grid-column: 1 / -1;
    margin-bottom: 5px;
    color: #8a96aa;
    font-size: 12px;
  }

  strong {
    font-size: 16px;
  }

  i {
    align-self: center;
    font-size: 18px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(7, 28, 71, 0.22);
  }
}

@media (max-width: 1100px) {
  .job-main {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .job-tags {
    justify-content: flex-start;
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }

  .detail-block,
  .detail-block + .detail-block {
    padding: 0;
    border-left: 0;
  }

  .detail-block + .detail-block {
    margin-top: 36px;
    padding-top: 36px;
    border-top: 1px solid #e8edf5;
  }

  .delivery-card {
    grid-template-columns: auto 1fr;
  }

  .mail-link {
    grid-column: 1 / -1;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
}

@media (max-width: 768px) {
  .recruit-shell {
    width: calc(100% - 32px);
  }

  .recruit-intro {
    padding: 62px 0 56px;
  }

  .intro-inner,
  .section-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .intro-copy h1 {
    font-size: 31px;
  }

  .intro-copy p {
    font-size: 16px;
  }

  .intro-stat {
    min-width: 0;
    padding: 20px 24px;

    strong {
      font-size: 40px;
    }
  }

  .position-section {
    padding: 62px 0 72px;
  }

  .section-heading {
    gap: 12px;
    margin-bottom: 28px;

    h2 {
      font-size: 31px;
    }
  }

  .job-summary {
    align-items: flex-start;
    padding: 23px 20px;
  }

  .job-number {
    flex-basis: 46px;
    height: 46px;
    margin-right: 14px;
    border-radius: 13px;
  }

  .job-main > strong {
    font-size: 20px;
    line-height: 1.4;
  }

  .toggle-icon {
    flex-basis: 36px;
    height: 36px;
    margin-left: 10px;

    i {
      top: 17px;
      left: 11px;
      width: 14px;
    }
  }

  .job-tags span {
    padding: 5px 9px;
    font-size: 11px;
  }

  .detail-grid {
    padding: 30px 20px 32px;
  }

  .detail-block li {
    padding-left: 38px;
    font-size: 14px;
  }

  .delivery-card {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 28px 24px;
  }

  .mail-visual {
    width: 54px;
    height: 54px;
  }

  .mail-link {
    grid-column: auto;

    strong {
      font-size: 14px;
      word-break: break-all;
    }
  }
}

@media (max-width: 480px) {
  .job-number {
    display: none;
  }

  .job-main {
    gap: 10px;
  }

  .job-summary {
    padding: 22px 16px;
  }

  .detail-grid {
    padding-right: 16px;
    padding-left: 16px;
  }
}
</style>
